module.exports = __webpack_public_path__ + "img/cp4-4.440f8173.jpg";